import React from 'react'
import { classNames } from '@app/utils/classes'
import { listHeight } from '../../cells/card/analytics-style'
import { AnalyticsCardMock } from './website-analytics-card-mock'

// analytics cell inner component
export const RenderAnalyticsMock = ({
  account,
  issuesInfo,
  domain,
  liveData,
  onlyLive,
}: any) => {
  if (account.analyticsDisabled) {
    return null
  }
  // authed users only
  if (issuesInfo || liveData.length) {
    return (
      <div className='relative'>
        <AnalyticsCardMock
          domain={domain}
          liveData={liveData}
          onlyLive={onlyLive}
        />
      </div>
    )
  }

  return (
    <div className='relative'>
      <div
        className={classNames(
          'w-full bg-gray-100 dark:bg-gray-800',
          listHeight
        )}
      ></div>
    </div>
  )
}
